(() => {
  if (customElements.get('ahead-sugar-pouch')) return;
  customElements.define('ahead-sugar-pouch', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
      this.classList.add('is-waiting');
      this._observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-filled')));
        this._observer.disconnect();
      }, { threshold: 0.45 });
      this._observer.observe(this);
    }
    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
      this._ready = false;
      this.classList.remove('is-waiting', 'is-filled');
    }
  });
})();
